// Dependencies
import React from 'react';
//import { useSpring, animated } from 'react-spring';
import _ from 'lodash';
import { Helpers } from '../../utils';

// Types
import { Components } from "../../types";
import styled, { css, useTheme } from 'styled-components'; 

// TODO: Refactor, optimise
export const Price = ({price, available, taxClass, taxable, pricePerUnitThreshold = -1, quantity, config: {general: {decimals, tax, currency, roundingPrecision}}, translations}: any) => {

    const { components }: any = useTheme();
    
    const priceArgs = {
        quantity,
        displayMode: _.isBoolean(taxable) ? (taxable ? 'include' : 'exclude') : null ?? tax.displayMode,
        taxClass: taxClass ?? tax.default,
        taxRates: tax.rates,
        precision: Math.abs(roundingPrecision),
        isOnSale: price?.sale && price.sale < price.regular
    }
//price?.sale && price.sale < price.regular ? price.regular : null, 
    // TODO: Refactor, optimise
    const prices = { 
        newPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, quantity: 1}) || 0,
        oldPrice: (priceArgs.isOnSale) ? Helpers.getPrice({price: price.regular, ...priceArgs, quantity: 1}) : 0 || 0, 
        currentPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, precision: 0}) || 0,
        currentPoints: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs}) || 0,
        currentSavings: priceArgs.isOnSale ? Helpers.getPrice({price: price.regular - price.sale, ...priceArgs}) : 0,
        currentOldPrice: (priceArgs.isOnSale) && price.regular ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0 || 0,
    }
    // const springs = useSpring({ 
    //     newPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, quantity: 1}) || 0,
    //     oldPrice: (priceArgs.isOnSale) ? Helpers.getPrice({price: price.regular, ...priceArgs, quantity: 1}) : 0 || 0, 
    //     currentPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, precision: 0}) || 0,
    //     currentPoints: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, precision: 0}) || 0,
    //     currentSavings: priceArgs.isOnSale ? Helpers.getPrice({price: price.regular - price.sale, ...priceArgs}) : 0,
    //     currentOldPrice: (priceArgs.isOnSale) && price.regular ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0 || 0,
    //     from: { 
    //         oldPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.sale, ...priceArgs}) : 0,  
    //         newPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0,
    //         currentOldPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.sale, ...priceArgs}) : 0,  
    //         currentPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0,
    //         currentPoints: 0,
    //         currentSavings: 0,
    //     },
    //     config: {
    //         duration: components.price.animationDuration
    //     }
    // })  

    if ( ! price?.regular && ! price?.sale ) {
        return null;
    }
 
    // TODO: Pad zeros when they should be there (resets when some state changes) > 19.00 >> 19
    // const getFormattedPrice = (type: 'oldPrice' | 'newPrice' | 'currentPrice' | 'currentOldPrice' | 'currentSavings') => springs[type].to((price: number) => Helpers.getRoundedPrice(price, priceArgs.precision).toFixed(decimals));
    // const getFormattedPoints = (type: 'currentPoints') => springs[type].to((price: number) => Helpers.getRoundedPrice(price, 0).toFixed(0));
    const getFormattedPrice = (type: 'oldPrice' | 'newPrice' | 'currentPrice' | 'currentOldPrice' | 'currentSavings') => Helpers.getRoundedPrice(prices[type], priceArgs.precision).toFixed(decimals).replace('.', ',');
    const getFormattedPoints = (type: 'currentPoints') => Math.floor(prices[type]) || 1;

    return ( 
        <PriceWrapper className="product-price__wrapper">
            {price?.sale && price.sale < price.regular && 
                <DisplayPrice {...{type: 'original', currency}}>{ getFormattedPrice('currentOldPrice') }</DisplayPrice>
            }
            <DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('currentPrice') }</DisplayPrice>

            {/* {available &&
                <PointsTextWrapper>
                    {
                        priceArgs.isOnSale && (<>
                            <span>Ušetrite&nbsp;</span>
                            <DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('currentSavings') }</DisplayPrice>
                            <span>&nbsp;a&nbsp;</span>
                        </>)    
                    }
                    <span>získajte&nbsp;</span>
                    <strong>{ getFormattedPoints('currentPoints') }</strong>
                    <span>&nbsp;{Number(getFormattedPoints('currentPoints') ) === 1 ? 'bod' : (prices.currentPoints < 5 ? 'body' : 'bodov')}</span>
                </PointsTextWrapper>
            } */}

            { pricePerUnitThreshold > 0 &&
                <PricePerUnit visible={quantity > 1}>
                    <div>
                        <strong>{`${translations.product.pricePerUnit}: `}</strong>
                        {price?.sale && price.sale < price.regular && <DisplayPrice {...{type: 'original', currency}}>{ getFormattedPrice('oldPrice') }</DisplayPrice> }
                        <DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('newPrice') }</DisplayPrice>
                    </div>
                </PricePerUnit>
            }

        </PriceWrapper>
    )
}

// TODO: Universal price display (type, value, currency, animated, ...)

export const PriceWrapper = styled.div<any>(
({ theme: { general, components: {price: style} } }) => css`
    display: flex;
    flex: 1;
    // align-items: flex-end;
    flex-direction: column;
    justify-content: center;
    text-align: right;
    font-size: 100%;

    /* &.product-price__wrapper {
        ${CurrentPrice} {
            ${Helpers.clamp('font-size', 1.625, 2.75)};
        }
    } */

`);

export const CurrentPrice = styled.ins<any>(
({ theme: { general, components: {price: style} } }) => css`
    ${Helpers.clamp('font-size', 1.75, 2.75)};
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    color: ${style.primaryTextColor};
    
`);

// TODO:         min-width: ${3 + 1 + 1 + decimals}ch; // Space for [000].[00]€
export const OriginalPrice = styled.del<any>(
({ theme: { general, components: {price: style} } }) => css`
    //${Helpers.clamp('font-size', 1, 1.5, 2.5)};
    ${Helpers.clamp('font-size', 1, 1.15, 1.5)};
    line-height: 1;
    font-weight: 400;
    color: ${style.secondaryTextColor};
`);

export const PricePerUnit = styled.small<any>(
({ visible, theme: { general, components: {price: style} } }) => css`
    position: absolute;
    color: #2b2d59;
    bottom: ${-1 * (0.5 + 1)}em; // line-height + spacing-top
    right: 0;
    width: 100%;
    overflow: hidden;
    ${Helpers.clamp('font-size', 0.75, 0.95, 3.5)};

    div {
        width: fit-content;
        display: inline-block;
        opacity: ${visible ? 1 : 0};
        transform: translateX(${visible ? 0 : 100}%);
        transition: all ${general.transition.duration} ${general.transition.timingFunction};
    }
    
    strong {
        font-weight: 400;
        margin-right: .15em;
    }
    
    ${OriginalPrice} {
        font-size: 1em;
        color: ${style.secondaryTextColor};
        margin-right: 0.25em;
    }

    ${CurrentPrice} {
        font-size: 1em;
        color: ${style.primaryTextColor};
        text-decoration: none;
    }
`);

const PointsTextWrapper = styled.div<any>(({theme: {general}}) => `
    &:first-letter {
        text-transform: uppercase;
    }

    color: #2b2d59;
    margin-top: 0.25em;
    
    & > * {
        ${Helpers.clamp('font-size', 0.85, 1.25, 2.5, true)}
    }

    @media (max-width: ${Helpers.getBreakpoint('mobile', 'md')}) {
        & {
            position: absolute;
            top: -2.25em;
            ${Helpers.clamp('right', -(Math.round(general.wrapper.padding.inline / 1.5)), -(general.wrapper.padding.inline), 2.5)};
            background: #f9f9f9;
            ${Helpers.clamp('padding', (Math.round(general.wrapper.padding.inline / 1.5)), (general.wrapper.padding.inline), 2.5)};
            padding-top: 0.25em !important;
            padding-bottom: 0.25em !important;
            border-radius: 0.625em 0.625em 0 0;
        }
    }
`)

export const CurrencySymbol = styled.span<any>(
    ({ position, theme: { general, components: {price: style} } }) => css`
    ${`margin-${position === 'after' ? 'left' : 'right'}`}: 0.1em;
`)

const priceDisplayMap: any = {
    current: CurrentPrice,
    original: OriginalPrice
}

export const DisplayPrice = ({type, children, currency: {position, symbol}}: any) => {

    const PriceWrapper = React.useMemo(() => (type in priceDisplayMap) ? priceDisplayMap[type] : priceDisplayMap.current, [type]);

    return (
        <PriceWrapper>
            {symbol && position === 'before' && <CurrencySymbol {...{position}}>{symbol}</CurrencySymbol>}
            <span>{ children }</span>
            {symbol && position !== 'before' && <CurrencySymbol {...{position}}>{symbol}</CurrencySymbol>}
        </PriceWrapper>
    )

}